import { createEl } from '../lib/dom';
import { SITE } from '../site/site-config';
import { createClientIllustration, createCollaboratorIllustration } from '../ui/audience-illustrations';

function bulletList(items: readonly string[]): HTMLElement {
  const ul = createEl('ul', { className: 'sv-audience__list' });
  for (const text of items) {
    ul.appendChild(createEl('li', {}, [text]));
  }
  return ul;
}

export function renderAudiences(target: HTMLElement): void {
  const { clients, collaborators } = SITE.audiences;

  const section = createEl(
    'section',
    {
      className: 'sv-section',
      id: 'para-quien',
      'aria-labelledby': 'aud-title',
    },
    [
      createEl('div', { className: 'sv-inner' }, [
        createEl('h2', { className: 'sv-section__title', id: 'aud-title' }, [SITE.audiencesIntro]),
        createEl('div', { className: 'sv-card-grid sv-card-grid--2' }, [
          createEl('article', { className: 'sv-card sv-audience' }, [
            createClientIllustration(),
            createEl('h3', { className: 'sv-card__title' }, [clients.title]),
            bulletList(clients.bullets),
          ]),
          createEl('article', { className: 'sv-card sv-audience' }, [
            createCollaboratorIllustration(),
            createEl('h3', { className: 'sv-card__title' }, [collaborators.title]),
            bulletList(collaborators.bullets),
          ]),
        ]),
      ]),
    ]
  );
  target.appendChild(section);
}
